import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

import { DEFAULT_IMAGE_SIZE } from './constants';
import { type AvatarDefaultProps } from './types';

const AvatarDefault = (props: AvatarDefaultProps): React.JSX.Element => (
	<Avatar appearance="circle" size="medium" imageSize={DEFAULT_IMAGE_SIZE} {...props} />
);

export default AvatarDefault;
